module.exports = __webpack_public_path__ + "r-v3/img/camera_error.e0ffb605.svg";